export const syncSelectorWithSelection = (self) => {
  self._checkNoProcessingTask();
  const selection = self._getSelectionThrowable();
  const selector_controller = self._getSelectorControllerThrowable();
  const selected_els = selection.getSelectedEls();
  selector_controller.syncWith(selected_els);
};
